import React from 'react';
import HeroSection from '../components/homepage/HeroSection';
import TriagePortal from '../components/homepage/TriagePortal';
import '../styles/homepage.css';

// ═══════════════════════════════════════════════════════════════════
// HOMEPAGE - New immersive triage portal homepage
// ═══════════════════════════════════════════════════════════════════

const Homepage = () => {
  const scrollToPortal = () => {
    const portal = document.getElementById('portal');
    if (portal) {
      portal.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-[#020314]">
      {/* Hero Section with immersive background */}
      <HeroSection onScrollToPortal={scrollToPortal} />

      {/* Triage Portal with path selection */}
      <TriagePortal />
    </div>
  );
};

export default Homepage;